import React from "react";
import classNames from "classnames";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import moment from 'moment';
import Datetime from "react-datetime";
import Autosuggest from 'react-autosuggest';
// import AutosuggestHighlightMatch from 'autosuggest-highlight/match';
// import AutosuggestHighlightParse from 'autosuggest-highlight/parse';
import withStyles from "@material-ui/core/styles/withStyles";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
// import List from "@material-ui/core/List";
// import ListItem from "@material-ui/core/ListItem";
import Check from "@material-ui/icons/Check";
import Snackbar from '@material-ui/core/Snackbar';

// import Header from "../../../components/Header/Header.jsx";
import Button from "../../../components/CustomButtons/Button.jsx";
import GridContainer from "../../../components/Grid/GridContainer.jsx";
import GridItem from "../../../components/Grid/GridItem.jsx";
import Card from "../../../components/Card/Card.jsx";
import CardBody from "../../../components/Card/CardBody.jsx";
import CustomInput from "../../../components/CustomInput/CustomInput.jsx";
import BlackCustomTabs from "../../../components/CustomTabs/BlackCustomTabs";

import CustomNotification from "../../LandingPage/Sections/CustomNotification";

import headersStyle from "../../../assets/jss/material-kit-pro-react/views/sectionsSections/headersStyle.jsx";

import { filterAccommodations, filterTours } from "../../../actions/filterActions";
import backgroundImg from "../../../assets/img/landing-bg2.jpg";

const yesterday = Datetime.moment().subtract( 1, 'day' );
const nextYear = Datetime.moment('02/01/2020', 'DD/MM/YYYY');
const validDate = function( current ){
    return current.isAfter( yesterday ) && current.isBefore( nextYear );
};

/**
 * TODO: OJO con esto
 * */

const locations = [
    { id:'5ba2aba4f976b83038bc5268', city: 'Arcabuco', department: "Boyacá", img: 'https://image.ibb.co/iHAF5q/Arcabuco-48x48.jpg' },
    { id:'5ba2aba4f976b83038bc5289', city: 'Gachantivá', department: "Boyacá", img: 'https://image.ibb.co/iW4a5q/Gachantiva-48x48.jpg' },
    { id:'5ba2aba4f976b83038bc52a5', city: 'Paipa', department: "Boyacá", img: 'https://image.ibb.co/dm98Qq/Paipa-48x48.jpg' },
    { id:'5ba2aba4f976b83038bc52b0', city: 'Ráquira', department: "Boyacá", img: 'https://image.ibb.co/i3Hv5q/Raquira-48x48.jpg' },
    { id:'5ba2aba4f976b83038bc52cb', city: 'Sutamarchán', department: "Boyacá", img: 'https://image.ibb.co/epV4yA/Sutamarchan-48x48.jpg' },
    { id:'5ba2aba4f976b83038bc52de', city: 'Villa de Leyva', department: "Boyacá", img: 'https://image.ibb.co/cQPmBV/Villa-de-Leyva-48x48.jpg' }
];
// https://developer.mozilla.org/en/docs/Web/JavaScript/Guide/Regular_Expressions#Using_Special_Characters
function escapeRegexCharacters(str) {
    return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}
const getSuggestions = value => {
    const escapedValue = escapeRegexCharacters(value.trim());
    const regex = new RegExp('\\b' + escapedValue, 'i');
    return locations.filter(locat =>
        regex.test(getSuggestionValue(locat))
    )
};
function getSuggestionValue(suggestion) {
    return `${suggestion.city}`;
}
function renderSuggestion(suggestion, { query }) {
    // const suggestionText = `${suggestion.city} (${suggestion.department})`;
    // const matches = AutosuggestHighlightMatch(suggestionText, query);
    // const parts = AutosuggestHighlightParse(suggestionText, matches);
    return (
        <span className='suggestion-content' style={{ backgroundImage: `url(${suggestion.img})` }}>
            <span className="name">
                {/* {
                    parts.map((part, index) => {
                        const className = part.highlight ? 'highlight' : null;

                        return (
                            <span className={className} key={index}>{part.text}</span>
                        );
                    })
                } */}
            </span>
        </span>
    );
}

class SectionHeaders extends React.Component {
    constructor() {
        super();
        this.state = {
            location: '',
            checkIn: moment().add(1, 'day').startOf('day'), // Siempre debe ser un moment
            checkOut: moment().add(2, 'day').startOf('day'), // Siempre debe ser un moment
            numPersons: 2,
            errors: {},
            checked: [],
            openDatePicker: false,
            suggestions: []
        };
    }

    componentWillReceiveProps(nextProps) {
        if (!!nextProps.errors && !!nextProps.errors.message) {
            this.handleClickNotification(nextProps.errors.message, 'error');
            let errors = {};
            if (!!nextProps.errors.errors && nextProps.errors.errors.length>0) {
                for (let i=0; i<nextProps.errors.errors.length; i++) {
                    let actualField = nextProps.errors.errors[i];
                    errors[actualField.field] = actualField.message;
                }
                this.setState({ errors });
            }
        }
    }

    componentDidMount() {
        if (!!localStorage.getItem('FILTERS')) {
            let filters = JSON.parse(localStorage.getItem('FILTERS'));
            if (!!filters.full_lease && !!filters.location) {
                if (filters.full_lease===true) this.handleToggle(1);
                this.setState({ location: filters.location, checkIn: moment(filters.checkIn), checkOut: moment(filters.checkOut), numPersons: filters.numPersons });
            } else {
                this.setState({ checkIn: moment(filters.checkIn), checkOut: moment(filters.checkOut), numPersons: filters.numPersons });
            }
        }
    }

    handleToggle = value => {
        const { checked } = this.state;
        const currentIndex = checked.indexOf(value);
        const newChecked = [...checked];

        currentIndex === -1 ? newChecked.push(value) : newChecked.splice(currentIndex, 1);

        this.setState({ checked: newChecked });
    };

    handleClickNotification = (messageNotification, variantNotification) => {
        this.setState({ openNotification: true, messageNotification, variantNotification });
    };

    handleCloseNotification = (event, reason) => {
        if (reason === 'clickaway') { return; }
        this.setState({ openNotification: false });
    };

    onChangeCustomInput = () => e => {
        if (!!e.target.id) {
            this.setState({ [e.target.id]: e.target.value, errors: {} });
        } else {
            console.error('Error actualizando la informacion ingresada', 'error');
        }
    };

    /* Suggestions functions */
    onChangeSuggestion = (event, { newValue }) => {
        this.setState({ location: newValue });
    };

    onSuggestionsFetchRequested = ({ value }) => {
        this.setState({ suggestions: getSuggestions(value) });
    };

    onSuggestionsClearRequested = () => {
        this.setState({ suggestions: [] });
    };

    shouldRenderSuggestions = value => {
        return value.length>=0;
    };

    // renderSuggestionsContainer({ containerProps, children, query }) {
    //     return (
    //         <div {... containerProps}>
    //             {children}
    //         </div>
    //     );
    // }
    /* End Suggestions functions */

    onChangeDateInput = (inputName, e) => {
        if (!!e && !!inputName) {
            this.setState({ [inputName]: e, errors: {}, openDatePicker: false });
        } else {
            this.setState({ [inputName]: '', errors: {}, openDatePicker: false });
        }
    };

    onSubmitAccommodation = e => {
        e.preventDefault();

        const { location, checkIn, checkOut, numPersons, checked } = this.state;

        if (location!=='') {
            if (numPersons > 0) {
                if (checkIn!=='' && checkOut!=='') {

                    if (checkIn.isBefore(checkOut)) {

                        if (!!locations.find(x => x.city === location)) {
                            let filterData = {
                                location: locations.find(x => x.city === location).id,
                                checkIn: checkIn.format("DD")+"%2F"+checkIn.format("MM")+"%2F"+checkIn.format("YYYY"),
                                checkOut: checkOut.format("DD")+"%2F"+checkOut.format("MM")+"%2F"+checkOut.format("YYYY"),
                                numPersons,
                                full_lease: (checked.length>0)
                            };

                            localStorage.setItem('FILTERS', JSON.stringify({full_lease: filterData.full_lease, numPersons, location, checkIn, checkOut, showNotification: true}));
                            // WithRouter nos permite pasar this.props.history como parámetro
                            this.props.filterAccommodations(filterData, this.props.history);
                        } else {
                            this.handleClickNotification('En el momento no tenemos alojamientos en el municipio especificado. Por favor intenta con uno diferente', 'error');
                        }

                    } else {
                        let errors = {
                            checkIn: "Fecha no válida",
                            checkOut: "Fecha no válida"
                        };
                        this.setState({ errors });
                        this.handleClickNotification('El Check-In debe ser anterior al Check-Out', 'warning');
                    }

                } else {
                    let errors = {
                        checkIn: "Selecciona una fecha",
                        checkOut: "Selecciona una fecha"
                    };
                    this.setState({ errors });
                }
            } else {
                let errors = { numPersons:"Mínimo 1 huesped" };
                this.setState({ errors });
            }
        } else {
            let errors = { location:"Selecciona un municipio" };
            this.setState({ errors });
        }

    };

    onSubmitTour = e => {
        e.preventDefault();

        const { checkIn, checkOut, numPersons } = this.state;

        if (numPersons > 0) {
            if (checkIn!=='' || checkOut!=='') {

                if (checkIn.isBefore(checkOut)) {

                    let filterData = {
                        checkIn: checkIn.format("DD")+"%2F"+checkIn.format("MM")+"%2F"+checkIn.format("YYYY"),
                        checkOut: checkOut.format("DD")+"%2F"+checkOut.format("MM")+"%2F"+checkOut.format("YYYY"),
                        numPersons
                    };

                    localStorage.setItem('FILTERS', JSON.stringify({numPersons, checkIn, checkOut, showNotification: true}));
                    // WithRouter nos permite pasar this.props.history como parámetro
                    this.props.filterTours(filterData, this.props.history);
                } else {
                    let errors = {
                        checkIn: "Fecha no válida",
                        checkOut: "Fecha no válida"
                    };
                    this.setState({ errors });
                    this.handleClickNotification('El Check-In debe ser anterior al Check-Out', 'warning');
                }

            } else {
                let errors = {
                    checkIn: "Selecciona una fecha",
                    checkOut: "Selecciona una fecha"
                };
                this.setState({ errors });
            }
        } else {
            let errors = { numPersons:"Mínimo 1 huesped" };
            this.setState({ errors });
        }

    };

    render() {
        const { classes } = this.props;
        const { suggestions, errors } = this.state;

        return (
            <div>
                <div className={classes.pageHeader} style={{ backgroundImage: `url("${backgroundImg}")` }}>
                    <div className={classes.conatinerHeader2}>
                        <GridContainer>
                            <GridItem xs={12} sm={8} md={8} className={classNames( classes.mlAuto, classes.mrAuto, classes.textCenter )}>
                                <h1 className={classes.title+" "+classes.hiddenInMobile+" "+classes.vecShadowTitle}>Descansa en entornos rurales</h1>
                                <h3 className={classes.titleLandingMobile+" "+classes.hiddenInDesktop+" "+classes.vecShadowTitle}>Descansa en entornos rurales</h3>
                                <h4 className={classes.vecShadowSubtitle}>
                                    Relájate en el ambiente típico del Campo
                                </h4>
                            </GridItem>

                            {/* Meta search */}
                            <GridItem xs={12} sm={12} md={12} className={classNames(classes.mlAuto, classes.mrAuto)}>
                                <Card raised className={classes.metasearch}>
                                    {/* Custom Notification */}
                                    <Snackbar anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} open={this.state.openNotification} autoHideDuration={6000} onClose={this.handleCloseNotification}>
                                        <CustomNotification onClose={this.handleCloseNotification} variant={this.state.variantNotification} message={this.state.messageNotification}/>
                                    </Snackbar>
                                    {/* End Custom Notification */}

                                    <BlackCustomTabs
                                        plainTabs
                                        headerColor="blackTransparent"
                                        tabs={[
                                            {
                                                tabName: "Alojamientos",
                                                tabContent: (
                                                    <CardBody formHorizontal>
                                                        <form onSubmit={this.onSubmitAccommodation}>
                                                            <GridContainer>

                                                                <GridItem xs={12} sm={2} md={2} className={classes.inputContainersMetaS1}>
                                                                    <Autosuggest
                                                                        id="location"
                                                                        suggestions={suggestions}
                                                                        onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                                                                        onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                                                                        getSuggestionValue={getSuggestionValue}
                                                                        renderSuggestion={renderSuggestion}
                                                                        // renderSuggestionsContainer={this.renderSuggestionsContainer}
                                                                        shouldRenderSuggestions={this.shouldRenderSuggestions}
                                                                        inputProps={{
                                                                            placeholder: 'Ingresa una ciudad',
                                                                            value: this.state.location,
                                                                            onChange: this.onChangeSuggestion
                                                                        }}
                                                                    />
                                                                    <small className={classes.errorDisplay}>{!!errors.location ? errors.location : null}</small>
                                                                </GridItem>

                                                                <GridItem xs={12} sm={2} md={2} className={classes.inputContainersMetaS2}>
                                                                    <FormControl fullWidth>
                                                                        <Datetime
                                                                            id="checkIn"
                                                                            value={this.state.checkIn}
                                                                            closeOnSelect={true}
                                                                            closeOnTab={true}
                                                                            className={classes.compressedInput+" "+classes.inputWhite}
                                                                            dateFormat="DD/MM/YYYY"
                                                                            timeFormat={false}
                                                                            isValidDate={ validDate }
                                                                            onChange={ e => this.onChangeDateInput("checkIn", e) }
                                                                            inputProps={{
                                                                                placeholder: "Check-In",
                                                                                name: "checkIn",
                                                                                autoComplete: "off"
                                                                            }}
                                                                        />
                                                                    </FormControl>
                                                                    <small className={classes.errorDisplay}>{!!errors.checkIn ? errors.checkIn : null}</small>
                                                                </GridItem>

                                                                <GridItem xs={12} sm={2} md={2} className={classes.inputContainersMetaS2}>
                                                                    <FormControl fullWidth>
                                                                        <Datetime
                                                                            id="checkOut"
                                                                            value={this.state.checkOut}
                                                                            closeOnSelect={true}
                                                                            closeOnTab={true}
                                                                            className={classes.compressedInput+" "+classes.inputWhite}
                                                                            dateFormat="DD/MM/YYYY"
                                                                            timeFormat={false}
                                                                            isValidDate={ validDate }
                                                                            onChange={ e => this.onChangeDateInput("checkOut", e) }
                                                                            inputProps={{
                                                                                placeholder: "Check-Out",
                                                                                name: "checkOut",
                                                                                autoComplete: "off"
                                                                            }}
                                                                        />
                                                                    </FormControl>
                                                                    <small className={classes.errorDisplay}>{!!errors.checkOut ? errors.checkOut : null}</small>
                                                                </GridItem>

                                                                <GridItem xs={6} sm={2} md={2} className={classes.inputContainersMetaS2}>
                                                                    <CustomInput
                                                                        id = "numPersons"
                                                                        formControlProps={{ fullWidth: true, className: classes.compressedInput3+" "+classes.inputWhite }}
                                                                        inputProps={{
                                                                            type: "number",
                                                                            value: this.state.numPersons,
                                                                            onChange: this.onChangeCustomInput(),
                                                                            placeholder: "Num. Huéspedes",
                                                                            autoComplete: "off"
                                                                        }}
                                                                    />
                                                                    <small className={classes.errorDisplay}>{!!errors.numPersons ? errors.numPersons : null}</small>
                                                                </GridItem>

                                                                <GridItem xs={6} sm={2} md={2}>
                                                                    <div className={classes.compressedInput+" "+classes.inputWhite2}>
                                                                        <FormControlLabel
                                                                            control={
                                                                                <Checkbox
                                                                                    onClick={ () => this.handleToggle(1) }
                                                                                    checkedIcon={<Check className={classes.checkedIconWhite} />}
                                                                                    icon={<Check className={classes.uncheckedIconWhite} />}
                                                                                    classes={{ checked: classes.checked }}
                                                                                    checked={this.state.checked.indexOf(1) !== -1}
                                                                                />
                                                                            }
                                                                            classes={{ label: classes.label }}
                                                                            label="Aloj. completo"
                                                                        />
                                                                    </div>
                                                                    <small className={classes.errorDisplay}>{!!errors.full_lease ? errors.full_lease : null}</small>
                                                                </GridItem>

                                                                <GridItem xs={12} sm={2} md={2}>
                                                                    <Button block color="success" type="submit">
                                                                        Buscar
                                                                    </Button>
                                                                </GridItem>

                                                            </GridContainer>
                                                        </form>
                                                    </CardBody>
                                                )
                                            },
                                            {
                                                tabName: "Tours",
                                                tabContent: (
                                                    <CardBody formHorizontal>
                                                        <form onSubmit={this.onSubmitTour}>
                                                            <GridContainer>

                                                                <GridItem xs={12} sm={3} md={3}>
                                                                    <FormControl fullWidth>
                                                                        <Datetime
                                                                            id="checkIn"
                                                                            value={this.state.checkIn}
                                                                            closeOnSelect={true}
                                                                            closeOnTab={true}
                                                                            className={classes.compressedInput+" "+classes.inputWhite}
                                                                            dateFormat="DD/MM/YYYY"
                                                                            timeFormat={false}
                                                                            isValidDate={ validDate }
                                                                            onChange={ e => this.onChangeDateInput("checkIn", e) }
                                                                            inputProps={{
                                                                                placeholder: "Disponible desde",
                                                                                name: "checkIn",
                                                                                autoComplete: "off"
                                                                            }}
                                                                        />
                                                                    </FormControl>
                                                                    <small className={classes.errorDisplay}>{!!errors.checkIn ? errors.checkIn : null}</small>
                                                                </GridItem>

                                                                <GridItem xs={12} sm={3} md={3}>
                                                                    <FormControl fullWidth>
                                                                        <Datetime
                                                                            id="checkOut"
                                                                            value={this.state.checkOut}
                                                                            closeOnSelect={true}
                                                                            closeOnTab={true}
                                                                            className={classes.compressedInput+" "+classes.inputWhite}
                                                                            dateFormat="DD/MM/YYYY"
                                                                            timeFormat={false}
                                                                            isValidDate={ validDate }
                                                                            onChange={ e => this.onChangeDateInput("checkOut", e) }
                                                                            inputProps={{
                                                                                placeholder: "Disponible hasta",
                                                                                name: "checkIn",
                                                                                autoComplete: "off"
                                                                            }}
                                                                        />
                                                                    </FormControl>
                                                                    <small className={classes.errorDisplay}>{!!errors.checkOut ? errors.checkOut : null}</small>
                                                                </GridItem>

                                                                <GridItem xs={12} sm={3} md={3}>
                                                                    <CustomInput
                                                                        id = "numPersons"
                                                                        formControlProps={{ fullWidth: true, className: classes.compressedInput3+" "+classes.inputWhite }}
                                                                        inputProps={{
                                                                            type: "number",
                                                                            value: this.state.numPersons,
                                                                            onChange: this.onChangeCustomInput(),
                                                                            placeholder: "Num. Pasajeros",
                                                                            autoComplete: "off"
                                                                        }}
                                                                    />
                                                                    <small className={classes.errorDisplay}>{!!errors.numPersons ? errors.numPersons : null}</small>
                                                                </GridItem>

                                                                <GridItem xs={12} sm={3} md={3}>
                                                                    <Button block color="success" type="submit">
                                                                        Buscar
                                                                    </Button>
                                                                </GridItem>

                                                            </GridContainer>
                                                        </form>
                                                    </CardBody>
                                                )
                                            }
                                        ]}
                                    />
                                </Card>
                            </GridItem>
                            {/* End Meta search */}
                        </GridContainer>
                    </div>
                </div>
            </div>
        );
    }
}

SectionHeaders.propTypes = {
    filterAccommodations: PropTypes.func.isRequired,
    filterTours: PropTypes.func.isRequired,
    errors: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
    errors: state.errors
});

export default connect(mapStateToProps, { filterAccommodations, filterTours })( withRouter( withStyles(headersStyle)(SectionHeaders) ) );



// WEBPACK FOOTER //
// ./src/views/LandingPage/Sections/HeaderPhotoSection.jsx